var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity',{attrs:{"entity":"docs","presentation":"blank","params":{ 'dh-doc-id': _vm.document }}})
}
var staticRenderFns = []

export { render, staticRenderFns }